export default {
	// Config
	apiKey: "AIzaSyD-yg7CkuvHPZBaAvdDLXnhyrIOZcmR8uo",
  authDomain: "wizardtrees-mytrace.firebaseapp.com",
  projectId: "wizardtrees-mytrace",
  storageBucket: "wizardtrees-mytrace.firebasestorage.app",
  messagingSenderId: "206884524522",
  appId: "1:206884524522:web:3c0d6d4c7a00b02ab0a293"
};
